<template>
    <div>
        <img class="img" :src="templateArgs.data.url_img" />
    </div>
</template>

<script>
export default {
    name: 'templateImages',
    data: () => ({
        templateArgs: {}
    })
}
</script>

<style lang="scss" scoped>
.img {
    width: 70px;
}
</style>